import React, { useState } from "react";
import { useLocation } from "react-router-dom";


export default function DropDownSidebarItems({ label, icon, children, isOpen, onToggle }) {
  const location = useLocation();

  // Use local state if props are not provided (backward compatibility)
  const [isLocalOpen, setIsLocalOpen] = useState(false);
  const isControlled = isOpen !== undefined;

  const openState = isControlled ? isOpen : isLocalOpen;

  const handleOpen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isControlled) {
      onToggle();
    } else {
      setIsLocalOpen(!isLocalOpen);
    }
  };

  const sidebarItems = React.Children.toArray(children);
  const isCurrentLocation = sidebarItems.some((sidebarItem) => {
    return sidebarItem.props.goToPath === location.pathname;
  })

  // Auto-open if child is active
  React.useEffect(() => {
    if (isCurrentLocation && !openState && isControlled) {
      onToggle();
    } else if (isCurrentLocation && !openState && !isControlled) {
      setIsLocalOpen(true);
    }
  }, [isCurrentLocation]);


  return (
    <li className={`sidebar-dropdown-item ${isCurrentLocation ? "active" : ""} ${openState ? "open" : ""}`}>
      <a
        href="#"
        aria-expanded={openState ? "true" : "false"}
        className={"prevent-select allow-pointer-cursor has-arrow"}
        onClick={(e) => handleOpen(e)}
      >
        <i className={icon} />
        <span title={label} className="hide-menu">{label}</span>
      </a>
      <ul className="sidebar-submenu">
        <li className="sidebar-flyout-title" aria-hidden="true">{label}</li>
        {children}
      </ul>
    </li>
  );
};